import {useState, useEffect, useRef} from "react";
import FJLocalStore from './store/FJLocalStore'
import store from './reducer/reducer/FJRoot'
import {Provider} from 'react-redux'
import AppContent from "./AppContent";
import useLocalStore from './hooks/useLocalStore'
import mainAction from "./reducer/action/mainAction";
// TODO 本地测试需要引入 测试服和正式服需要屏蔽
// import './config/flexclip.config'
import './jquery.payment.min'

const init = () => {
    window.FJGlobalariable.modSubscription.network.getSubscription().then((response) => {
        // window.FJGlobalariable.modSubscription.updateSubscriptionInfo(response.data.subscription);
        let subscription = response.data.subscription
        store.dispatch(mainAction.setCurrentPlan({
            package: subscription.package,
            period: subscription.period,
            last4: subscription.last4,
            price: subscription.price,
            period_end: subscription.period_end,
            status: subscription.status,
            sub_type: subscription.sub_type ? subscription.sub_type : 'stripe',
        }));
        const teamSubscription = response.data.teamSubscription;
        if (teamSubscription) {
            store.dispatch(mainAction.setTeamSubscription({...teamSubscription}));
        }

        if (store.getState().mainReducer.planType === 'team') {
            store.dispatch(mainAction.changePayMethodAction(teamSubscription?.sub_type ?? 'stripe'))
        } else {
            store.dispatch(mainAction.changePayMethodAction(subscription.sub_type ? subscription.sub_type : 'stripe'))
        }
    }).catch((error) => {
    }).finally(() => {
    });

    let initCookie = (search) => {
        let result = /(\?|&)(coupon=.*?)(&|$)/.exec(search);
        if (result) {
            document.cookie = result[2] + '; expires=' + (new Date((new Date).getTime() + 24 * 60 * 60 * 1000)).toUTCString();
        }
    }
    initCookie(location.search)

    if (window.fjuser) {
        let update = () => {
            store.dispatch(mainAction.changeLoadingStatusAction(true))
            window.FJGlobalariable.modSubscription.network.getSubscription().then((response) => {
                window.FJGlobalariable.modSubscription.updateSubscriptionInfo(response.data.subscription);
                let subscription = response.data.subscription
                store.dispatch(mainAction.setCurrentPlan({
                    package: subscription.package,
                    period: subscription.period,
                    last4: subscription.last4,
                    price: subscription.price,
                    period_end: subscription.period_end,
                    status: subscription.status,
                    sub_type: subscription.sub_type ? subscription.sub_type : 'stripe',
                }));
                const teamSubscription = response.data.teamSubscription;
                if (teamSubscription) {
                    store.dispatch(mainAction.setTeamSubscription({...teamSubscription}));
                }
                if (store.getState().mainReducer.planType === 'team') {
                    store.dispatch(mainAction.changePayMethodAction(teamSubscription?.sub_type ?? 'stripe'))
                } else {
                    store.dispatch(mainAction.changePayMethodAction(subscription.sub_type ? subscription.sub_type : 'stripe'))
                }
            }).catch((error) => {
                store.dispatch(mainAction.changeLoadingStatusAction(false))
            }).finally(() => {
                store.dispatch(mainAction.changeLoadingStatusAction(false))
            });
        }

        if (window.fjuser.eventType) {
            // 监听登录事件
            window.fjuser.addListener(window.fjuser.eventType.login, (result, json) => {
                if (result) {
                    store.dispatch(mainAction.changeStepAction(1))
                    update()
                }
            }, true)
            // 监听退出账号事件
            window.fjuser.addListener(window.fjuser.eventType.logout, (result, json) => {
                if (result) {
                    store.dispatch(mainAction.changeStepAction(1))
                    store.dispatch(mainAction.setCurrentPlan({
                        package: 'free',
                        period: null,
                        last4: null,
                        price: null,
                        period_end: null,
                        status: null,
                        sub_type: '',
                    }));
                    store.dispatch(mainAction.setTeamSubscription(null));
                }
            }, true)
        }
    }
}

function App() {
    const [isLoading, setIsLoading] = useState(true);
    useLocalStore()
    useEffect(() => {
        FJLocalStore.initLanguage(() => {
            setIsLoading(false);
        });
    }, []);
    useEffect(() => {
        init()
    }, [])

    if (isLoading) {
        return null;
    }
    return (
        <Provider store={store}>
            <AppContent/>
        </Provider>
    );
}

export default App;

window.openSubscription = (entry, page = 'plans', isAnnual = true, selectPlanIndex = 1) => {
    window.FJGlobalariable.modSubscription.network.getSubscription().then((response) => {
        // window.FJGlobalariable.modSubscription.updateSubscriptionInfo(response.data.subscription);
        let subscription = response.data.subscription
        store.dispatch(mainAction.setCurrentPlan({
            package: subscription.package,
            period: subscription.period,
            last4: subscription.last4,
            price: subscription.price,
            period_end: subscription.period_end,
            status: subscription.status,
            sub_type: subscription.sub_type ? subscription.sub_type : 'stripe',
        }));
        const teamSubscription = response.data.teamSubscription;
        if (teamSubscription) {
            store.dispatch(mainAction.setTeamSubscription({...teamSubscription}));
        }
        if (store.getState().mainReducer.planType === 'team') {
            store.dispatch(mainAction.changePayMethodAction(teamSubscription?.sub_type ?? 'stripe'))
        } else {
            store.dispatch(mainAction.changePayMethodAction(subscription.sub_type ? subscription.sub_type : 'stripe'))
        }
    }).catch((error) => {
    }).finally(() => {
    });

    // 初始化state
    window.FJGlobalariable.modSubscription.state.page = page;
    // window.FJGlobalariable.modSubscription.state.hideBackBtn = page !== 'plans';
    // window.FJGlobalariable.modSubscription.state.isAnnual = isAnnual;
    window.isAnnually = isAnnual
    window.FJGlobalariable.modSubscription.entry = entry;
    // window.FJGlobalariable.modSubscription.state.selectPlan = window.FJGlobalariable.modSubscription.planData[selectPlanIndex];
    let obj = {
        entry: entry
    }

    // 兼容老页面
    if (typeof entry === 'string') {
        if (entry === 'pricing') {
            obj.method = 'single'
        } else {
            obj.method = 'popup'
        }
        obj.planType = 'personal'
    } else {
        const {minSeatCount, maxSeatCount} = store.getState().mainReducer;
        obj = {
            entry: entry?.entry ?? 'default',
            method: entry?.method ?? 'popup',
            planType: entry?.planType ?? 'personal',
            additionalSeatCount: entry?.additionalSeatCount,
            calculatorSeatCount: Math.min(Math.max(Number(entry?.calculatorSeatCount) || minSeatCount, minSeatCount), maxSeatCount)
        };
        window.FJGlobalariable.modSubscription.entry = obj.entry;
    }

    const lastPlanType = store.getState().mainReducer.planType;
    store.dispatch(mainAction.openSubscribeView(obj));

    // 团队套餐暂不支持分区定价
    if (obj.planType === 'team') {
        // 如果之前应用了个人套餐的折扣码，切换到团队去除
        if (lastPlanType !== 'team') {
            store.dispatch(mainAction.setDataInfo({
                appliedCoupon: null,
            }));
        }
        return;
    }

    if (window.FJTier) {
        window.FJTier.check(true, () => {
            window.FJTier.addListener((data) => {
                if (!data) return
                let {coupon, discount} = data;
                let option = {coupon: coupon, rate: 1.0 - discount / 100}
                let obj = {}
                if (option.coupon && option.rate >= 0 && option.rate <= 100) {
                    obj.coupon = option.coupon
                    obj.rate = option.rate
                    obj.openDiscount = true
                    store.dispatch(mainAction.setDiscountConfAction(obj))
                }
                window.FJTier.apply();
            })
        });


        // window.FJTier.check()
    }
}
window.changeLanguageSubscribe = (language) => {
    FJLocalStore.switchLanguage(language)
}

window.openChangeCardModal = (title, shouldHideLoading, callback = () => {
}, teamId) => {
    store.dispatch(mainAction.openEditCardInfoPopup({
        title: title,
        shouldHideLoading: shouldHideLoading,
        callback: callback,
        teamId,
    }))
}
